import { render, staticRenderFns } from "./InformationsGenerales.vue?vue&type=template&id=246f1acf&"
import script from "./InformationsGenerales.vue?vue&type=script&lang=js&"
export * from "./InformationsGenerales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports